

































































import Vue from "vue";
import MoneyDisplay from "@/components/MoneyDisplay.vue";
import store, { InvoiceFlowStore } from "../services/InvoiceFlowStore";
import { CompositeFilterDescriptor, filterBy, FilterDescriptor } from "@progress/kendo-data-query";
import { DropDownList } from "@progress/kendo-vue-dropdowns";

interface Data {
  store: InvoiceFlowStore;
  filter: CompositeFilterDescriptor;
  inVatCountOptions: { id: boolean | null; name: string }[];
}

interface Methods {
  filterChange(e: { filter: CompositeFilterDescriptor }): void;
  inVatCountDropdownFilterChange(event: Event): void;
}

interface Computed {
  columns: any;
  filteredItems: any;
  inVatCountChanged: boolean;
}

export default Vue.extend<Data, Methods, Computed, {}>({
  components: {
    MoneyDisplay,
    "k-dropdown-list": DropDownList,
  },

  props: {
    items: {
      type: Array as () => string[],
    },
    invCurrency: String,
  },

  data() {
    return {
      store,
      filter: {
        logic: "and",
        filters: [],
      },
      inVatCountOptions: [
        { id: null, name: "Összes" },
        { id: true, name: "Levonható" },
        { id: false, name: "Nem levonható" },
      ],
    }
  },

  methods: {
    filterChange(e: { filter: CompositeFilterDescriptor }) {
      this.filter = e.filter;
    },

    inVatCountDropdownFilterChange(event: Event) {
      const target = event.target as unknown as { value: { id: boolean | null; name: string } };
      const selected = target.value;
      
      const currentFilters = this.filter?.filters ?? [];
      const newFilters = currentFilters.filter(f => {
        return 'field' in f && (f as FilterDescriptor).field !== 'inVatCount';
      });

      if (selected && selected.id !== null) {
        newFilters.push({
          field: 'inVatCount',
          operator: 'eq',
          value: selected.id,
        });
      }
      this.filter = {
        logic: this.filter?.logic ?? 'and',
        filters: newFilters,
      };
    },
  },

  computed: {
    columns: () => [
      {
        field: "name",
        title: "Név",
        cell: "name",
        headerClassName: "left_text",
        className: "left_text",
      },
      {
        field: "currNetto",
        title: "Számla tétel nettó",
        cell: "currNetto",
        headerClassName: "right_text",
        className: "right_text",
      },
      {
        field: "currBrutto",
        title: "Számla tétel bruttó",
        cell: "currBrutto",
        headerClassName: "right_text",
        filterClassName: "right_filter",
        className: "right_text",
      },
      {
        field: "currVat",
        title: "Számla tétel áfa",
        cell: "currVat",
        headerClassName: "right_text",
        className: "right_text",
      },
      {
        field: "inVatCount",
        title: "Levonható",
        cell: "inVatCount",
        filterCell: "accStatusFilterTemplate",
        headerClassName: "right_text",
        className: "right_text",
      },
      { width: 0 }
    ],

    filteredItems() {
      return this.filter ? filterBy(this.$props.items, this.filter) : this.$props.items;
    },

    inVatCountChanged() {
      return this.store.vatDivisionItemGroups.some((group, i) =>
        group.items.some((item, j) =>
          item.inVatCount !== this.store.originalVatDivisionItemGroups[i].items[j].inVatCount
        )
      );
    }
  },

  watch: {
    'store.vatDivisionItemGroups': {
      deep: true,
      handler() {
        this.store.reCalcVatItems = this.inVatCountChanged;
      }
    }
  },
});
